import React, { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function AutomotiveMainHighlight() {
  const [offset, setOffset] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const {
        top,
        height
      } = sectionRef.current.getBoundingClientRect();
      if (top < window.innerHeight && top + height > 0) {
        setOffset(window.scrollY * 0.4);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="18785" id="hero-bemvindo" ref={sectionRef} className="bg-background text-foreground relative h-screen min-h-[600px] w-full overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 h-[120%] w-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/medical_hero_professional.png)",
      transform: `translateY(-${offset * 0.2}px)`
    }}>
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-[var(--color-background)]" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div className="animate-fade-in-up max-w-4xl space-y-8">
          <h1 className="font-default text-5xl font-bold tracking-tight text-white sm:text-6xl md:text-7xl lg:text-8xl">
            <span className="text-primary">Doctorice</span>
            <br />
            Inovação Médica
          </h1>

          <p className="font-default mx-auto max-w-[60ch] text-lg font-normal text-gray-100 sm:text-xl md:text-2xl">
            Soluções avançadas em equipamentos e consultoria clínica para transformar
            o seu atendimento e elevar o padrão da sua instituição de saúde.
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-sm group relative h-14 overflow-hidden rounded-md px-10 text-lg font-semibold transition-all duration-300">
              <Link to="/SolutionsPage">
                <span className="relative z-10 flex items-center gap-2">
                  Ver Soluções
                  <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
                {}
                <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000 group-hover:translate-x-full" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[var(--color-background)] to-transparent z-20" />
    </section>;
}